export enum SearchFormType {
  Airports = 'airports',
  Activities = 'activities',
  AviationEvents = 'events',
  FlyingClubs = 'flyingclubs',
  FlightSchools = 'flightschools',
  Universities = 'universities',
  Fbos = 'fbos',
  ServiceRepair = 'servicerepair',
  RentalSales = 'rentalsales',
  FuelPrice = 'fuel'
}
